import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const divisionMasterUpdateOrganizationStoreSlice = createSlice({
  name: 'divisionMasterUpdateOrganizationStore',
  initialState: { divisionMasterUpdateOrganizationStore: initialState },
  reducers: {
    divisionMasterUpdateOrganizationStoreApi: (state, data) => {
      state.divisionMasterUpdateOrganizationStore = data.payload;
    },
  },
});

export const {
  divisionMasterUpdateOrganizationStoreApi,
} = divisionMasterUpdateOrganizationStoreSlice.actions;

export default divisionMasterUpdateOrganizationStoreSlice.reducer;
